import type { ReactNode } from 'react';

// A small inline banner for form-level error/success messages. Errors use
// role="alert" so screen readers announce them.
export default function FormBanner({
  kind,
  children,
}: {
  kind: 'error' | 'success';
  children: ReactNode;
}) {
  // Error uses the themeable danger token (legible on dark AND light); success
  // stays semantic green with both-theme-friendly tints.
  const cls =
    kind === 'error'
      ? 'border-[color-mix(in_srgb,var(--cad-danger,#7f1d1d)_45%,transparent)] bg-[color-mix(in_srgb,var(--cad-danger,#f87171)_14%,transparent)] text-[var(--cad-danger,#fecaca)]'
      : 'border-emerald-600/40 bg-emerald-500/12 text-emerald-400';
  return (
    <div role={kind === 'error' ? 'alert' : 'status'} className={`rounded-md border px-3 py-2 text-sm ${cls}`}>
      {children}
    </div>
  );
}
